// extracted by mini-css-extract-plugin
module.exports = {"logo":"index_logo__1DxP-","account":"index_account__5M7Za","headerMenu":"index_headerMenu__3SsBN"};